module.exports = __webpack_public_path__ + "static/EM2-2a5543d783fd1ab0e933eff08c52bbbe.jpg";